import React from 'react';
import { CreditMetricContainer } from './CreditMetricContainer';
import { useFormContext } from 'react-hook-form';
import { formatTransactionDateDisplayText } from './creditTransactionsUtils';
import { useCreditDetails } from 'src/use-cases/settings/useCreditTransactions';

export const CreditMetrics: React.FC = () => {
  const { watch } = useFormContext();
  const formValues = watch();
  const selectedTransactionDates = formValues.transactionDate;
  const isTransactionDatesInitialized = selectedTransactionDates !== null;
  const selectedBilledEntityId = formValues.billedEntityId ? Number(formValues.billedEntityId) : null;

  // Use the selected entity ID from dropdown or fallback to Redux store selection
  const currentEntityId = selectedBilledEntityId || 0;

  // Fetch credit details for the selected entity — skip until transaction dates are initialized
  const { data: creditDetails, isLoading } = useCreditDetails(isTransactionDatesInitialized ? currentEntityId : 0, undefined, selectedTransactionDates ?? []);

  // Format display text for transaction date button
  const transactionDateDisplayText = formatTransactionDateDisplayText(selectedTransactionDates ?? [], ' - ');

  // Format expiry dates
  const formatExpiryDate = (dateString?: string) => {
    if (!dateString) return undefined;
    return new Date(dateString).toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  // Remaining Credits data
  const remainingCreditsItems = [
    {
      label: 'Invoice Credits',
      value: creditDetails?.remainingInvoiceCredit,
      isLoading,
      expiry: formatExpiryDate(creditDetails?.invoiceCreditExpirationDate),
    },
    {
      label: 'Shipment Credits',
      value: creditDetails?.remainingShipmentCredit,
      isLoading,
      expiry: formatExpiryDate(creditDetails?.shipmentCreditExpirationDate),
    },
  ];

  // Credits Consumed data
  const consumedCreditsItems = [
    {
      label: 'Invoice Credits',
      value: creditDetails?.consumedInvoiceCredit,
      isLoading,
      expiry: transactionDateDisplayText,
    },
    {
      label: 'Shipment Credits',
      value: creditDetails?.consumedShipmentCredit,
      isLoading,
      expiry: transactionDateDisplayText,
    },
  ];

  return (
    <div className='space-y-6'>
      {/* Credit Sections in 2 columns */}
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        {/* Remaining Credits Section */}
        <CreditMetricContainer title='Remaining Credits' items={remainingCreditsItems} />

        {/* Credits Consumed Section */}
        <CreditMetricContainer title='Credits Consumed' items={consumedCreditsItems} />
      </div>
    </div>
  );
};
